import React from "react";
import styles from "./404.module.css";
import { HiArrowLongLeft } from 'react-icons/hi2';
import { NavLink } from "react-router-dom";

function NotFound() {
  return (
    <div className={styles.body404}>
      <div className={styles.center404}>
        <div className={styles.column404}>
          <img className={styles.logo404} alt="logo" />
          <h1>404</h1>
          <p>
            Página não encontrada
          </p>
          <p>Clique aqui para voltar</p>
          <NavLink to={"/"} className={styles.circle404}>
            <HiArrowLongLeft color={"var(--background)"} size={32}/>
          </NavLink>
        </div>
      </div>
    </div>
  );
}

export default NotFound;